// extracted by mini-css-extract-plugin
export default {"tabGroupContainer":"Tabs_tabGroupContainer__uSBsP","tabHeader":"Tabs_tabHeader__oMtJ-","tabList":"Tabs_tabList__hJ08D","tabContainer":"Tabs_tabContainer__rSrRl"};